import { render, staticRenderFns } from "./Filecreate.vue?vue&type=template&id=a529277e&scoped=true"
import script from "./Filecreate.vue?vue&type=script&lang=js"
export * from "./Filecreate.vue?vue&type=script&lang=js"
import style0 from "./Filecreate.vue?vue&type=style&index=0&id=a529277e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a529277e",
  null
  
)

export default component.exports